<!-- eslint-disable max-len -->
<template>
  <div
    :class="{
      'object-container-automation' : !onProperties,
      'object-active' : blockActive || (!onProperties && id === propertiesIDBlock),
      'object-disabled': !onProperties && isDisableBlock
    }"
    class="position-relative"
    style="cursor:default"
    @mouseover="pauseZoom"
    @mouseleave="resumeZoom"
  >
    <!-- Disable Block -->
    <div
      v-if="onProperties"
      :style="[onFullscreen ? { 'right': '55px', 'top': '-45px' } : { 'right': '55px', }]"
      class="toggle-disable-block"
    >
      <j-switch v-model="disable_block" />

      <!-- Tooltip -->
      <div class="tooltip-toggle-disable">
        {{ disable_block ? 'Disable' : 'Enable' }} this block
      </div>
    </div>

    <template v-if="!onProperties">
      <img
        src="@/assets/new-form-ui/dragged.svg"
        class="icon-drag"
      >
      <img
        :src="require('@/assets/automation/script.svg')"
        width="20"
        height="20"
        class="m__r--5">
      <span class="title-automation m__r--5">SCRIPT</span>
      <span class="id-block-automation">{{ dataEdit ? `#${dataEdit.id}` : '' }}</span>
    </template>
    <img
      v-if="!onProperties"
      :src="require('@/assets/automation/config.svg')"
      width="20"
      height="20"
      class="pull-right cursor-pointer"
      @click="showProperties">

    <div v-if="onProperties">
      <b-form-group
        :class="{'error-input' : $v.data_js.javascript.$error}"
        class="m__t--15">
        <label> Javascript </label>
        <j-monaco-editor
          v-if="showEditor"
          ref="scriptEditor"
          :value="data_js.javascript"
        />
      </b-form-group>

      <!-- Configuration -->
      <div class="section-border mt-3 mb-4">
        <p class="title-section">Configuration</p>
        <p class="desc-section">Additional Action block feature</p>

        <div class="config-toggle">
          <div class="wrap-config-toggle-desc">
            <p class="title-config-toggle">Asynchronous</p>
            <p class="desc-config-toggle">
              Processing Block that allows  to execute tasks simultaneously without having to wait for previous tasks to complete first.
            </p>
          </div>
          <j-switch v-model="data_js.is_async" />
        </div>
      </div>

      <hr>
      <span class="title-automation">Container</span>
      <b-form-group :class="{'error-input' : $v.data_js.variable_name.$error}">
        <label> Variable Name </label>
        <j-input
          v-model="$v.data_js.variable_name.$model"
          :error-required="$v.data_js.variable_name.$error"
          :max-length="255"
          placeholder="Variable Name"/>
      </b-form-group>
    </div>
    <div v-else>
      <div class="trigger__label-variable ellipsis m__t--10">
        <img
          :src="require('@/assets/automation/variable.png')"
          width="20"
          height="20"
          class="m__r--10">
        {{ data_js.variable_name }}
        <j-monaco-editor
          v-show="false"
          ref="scriptEditor"
          :value="data_js.javascript"
        />
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-console, no-nested-ternary */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapMutations, mapState } from 'vuex';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jSwitch from '@/components/inputs/jSwitch';
// Mixins
import jMixPanZoom from '@/mixins/visual-programming/jMixPanZoom';
import jMixAutomation from '@/mixins/visual-programming/jMixAutomation';

export default {
  name: 'JAutomationJavascript',
  components: {
    jMonacoEditor,
    jSwitch,
  },
  mixins: [
    jMixPanZoom,
    jMixAutomation,
  ],
  props: {
    id: {
      type: Number,
      default: 0,
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
    dataIndexParent: {
      type: Number,
      default: 0,
    },
    dataIndexParentUp1: {
      type: Number,
      default: 0,
    },
    dataPosition: {
      type: String,
      default: '',
    },
    dataPositionParent: {
      type: String,
      default: '',
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
    dataHistory: {
      type: Object,
      default: () => {},
    },
    onProperties: {
      type: Boolean,
      default: false,
    },
    onFullscreen: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Number,
      default: 0,
    },
    dataParent: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data_js: {
        javascript: '',
        variable_name: '',
        is_async: false,
        is_disable: false,
      },
      disable_block: false,
      darkMode: false,
      blockActive: false,
      blockError: false,
      showEditor: false,
    };
  },
  computed: {
    ...mapState('jStoreAutomation', ['propertiesOpened', 'propertiesIDBlock']),
  },
  watch: {
    dataEdit() {
      this.setValueOnProperties();
      // Set disable block according to parent
      this.updateIsDisableBlock();
    },

    dataHistory() {
      this.setValueOnProperties();
    },

    propertiesOpened(val) {
      if (!val) this.blockActive = false;
    },

    // eslint-disable-next-line func-names
    'data_js.variable_name': function (val) {
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.data_js.variable_name = val.replace(regexSymbol, '').replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line func-names
    'data_js.is_disable': function (val) {
      this.disable_block = !val;
    },

    disable_block(val) {
      this.data_js.is_disable = !val;
    },
  },
  created() {
    this.setValueOnProperties();
  },
  mounted() {
    // Set disable block according to parent
    this.updateIsDisableBlock();

    setTimeout(() => {
      this.showEditor = true;
    }, 100);
  },
  methods: {
    ...mapMutations('jStoreAutomation', ['setPropertiesOpened']),

    setValueOnProperties() {
      this.data_js.javascript = this.dataHistory ?
        this.dataHistory.javascript :
        (this.dataEdit ? this.dataEdit.javascript : '');

      this.data_js.variable_name = this.dataHistory ?
        this.dataHistory.container_variable :
        (this.dataEdit ? this.dataEdit.container_variable : '');

      this.data_js.is_async = this.dataHistory ?
        this.dataHistory.is_async :
        (this.dataEdit ? this.dataEdit.is_async : false);

      this.data_js.is_disable = this.dataHistory ?
        this.dataHistory.is_disable :
        (this.dataEdit ? this.dataEdit.is_disable : false);

      this.disable_block = !this.data_js.is_disable;
      this.blockError = false;
    },

    validateData() {
      this.$v.data_js.$touch();
      if (this.onProperties) {
        return this.$v.data_js.$error || !this.$refs.scriptEditor.getData();
      }
      return this.$v.data_js.$error;
    },

    getData() {
      return new Promise((resolve, reject) => {
        if (!this.validateData()) {
          const data = {
            type: 'javascript',
            javascript: this.onProperties ? this.$refs.scriptEditor.getData() : this.data_js.javascript,
            container_variable: this.data_js.variable_name,
            is_async: this.data_js.is_async,
            is_disable: this.data_js.is_disable,
          };
          if (this.dataEdit && this.dataEdit.id) {
            data.id = this.dataEdit.id;
          }
          resolve(data);
        } else {
          reject(null);
        }
      });
    },

    sendDataToggleFullScreen() {
      return new Promise((resolve) => {
        const data = {
          type: 'javascript',
          javascript: this.onProperties ? this.$refs.scriptEditor.getData() : this.data_js.javascript,
          container_variable: this.data_js.variable_name,
          is_async: this.data_js.is_async,
          is_disable: this.data_js.is_disable,
        };
        if (this.dataEdit && this.dataEdit.id) {
          data.id = this.dataEdit.id;
        }
        resolve(data);
      });
    },

    showProperties() {
      if (this.propertiesOpened) {
        this.setPropertiesOpened({
          open: false,
        });

        setTimeout(() => {
          this.blockActive = true;
          this.setPropertiesOpened({
            open: true,
            type: 'javascript',
            data: this.dataEdit,
            index: this.dataIndex,
            row: this.row,
            dataParent: this.dataParent,
            idBlock: this.id,
          });
        }, 100);
      } else {
        this.blockActive = true;
        this.setPropertiesOpened({
          open: true,
          type: 'javascript',
          data: this.dataEdit,
          index: this.dataIndex,
          row: this.row,
          dataParent: this.dataParent,
          idBlock: this.id,
        });
      }
    },

    setErrorBlock() {
      this.blockError = true;
    },

    clearErrorBlock() {
      this.blockError = false;
    },
  },
  validations() {
    return {
      data_js: {
        javascript: {},
        variable_name: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/jVPBlockJavascript.vue